import store from "@/store";
import { PERMISSION_CONFIGS, GET_PERMISSION_NAME } from "@/common/constants/permission";
import { ROLE_TYPES } from '@/common/constants/role';
import { findChannelSync } from '_js/find-channel'
import Vue from "vue";
import { CHANNEL_TYPES } from '@/common/constants/channel';
import Cache from '_lib/DataCache'
import { binaryListToBigIntNum, transformToBinaryList } from "./utils/utilsArray";
const DEFAULT_TOURIST_PERMISSIONS = 2

class Permission {
  constructor() {
    this.initProperty()
    this.permissionStateCache = Vue.observable({})
  }
  findChannelPermissionData (channel_id, channels) {
    const channel = findChannelSync(channel_id, channels)
    if(!channel) {
      const groupData = store.getters.out_screen_group_info[channel_id]
      return groupData?.permission_overwrites
    } else {
      return channel.permission_overwrites
    }
  }
  /**
   * @param {string} type 
   * @param {object | string} channel_data // {room_id, channel_id} 或 channel_id
   * @param {boolean} needInfo 
   * @returns 
   */
  judge(type, channel_data, needInfo = false, data = {}) {
    const {roles, my_roles, channels, user_info} = data
    
    // 默认noCache不开启，如果当前判断的用户信息不是当前登录用户，则开启noCache
    let noCache = false
    if(user_info && user_info.user_id != store.getters.user_info?.user_id){
      noCache = true
    }
    
    let channel_id, room_id
    if (channel_data && typeof channel_data === 'object') {
      channel_id = channel_data.channel_id
      room_id = channel_data.room_id
    } else if (channel_data) {
      channel_id = channel_data
    }
    if (!room_id) room_id = this.cur_room_data.room_id
    let cacheKey = type + ':' + (channel_id || 0)
    if (!noCache && this.permissionStateCache[room_id] && this.permissionStateCache[room_id][cacheKey] !== undefined) { // 如果有缓存直接返回
      if (needInfo && !this.permissionStateCache[room_id][cacheKey]) {
        let permissionKey = cacheKey.split(':')[0]
        Vue.prototype.$toast.error(`无法${GET_PERMISSION_NAME(permissionKey)}，暂无相关权限`)
      }
      return this.permissionStateCache[room_id][cacheKey]
    }
    let permissionInfo = this.getPermissionInfo(this.handlePermissionUpdate({ channel_id, room_id, roles, my_roles_ids: my_roles, channels, user_info }))
    const index = permissionInfo.findIndex(item => item.key === type);
    if (index == -1) {
      return false;
    }
    // 如果是私密频道的话，并且没有被隐藏，将以下2个权限固定开启
    const channel = findChannelSync(channel_id, channels);
    if (channel && channel.is_private && !channel.not_show) {
      const viewingChannel = permissionInfo.find(item => item.key === 'ViewingChannel')
      viewingChannel.data = 1
      if (channel.channel_type === CHANNEL_TYPES.audio) {
        const joinAudioChannel = permissionInfo.find(item => item.key === 'JoinAudioChannel')
        joinAudioChannel.data = 1
      }
    }
    // 具备当前权限或具备管理员权限
    let isPass = permissionInfo[index].data || permissionInfo[0].data;

    // Debug时使用
    // if(type === 'ManageHost') {
    //   console.trace("🚀 ~ Permission ~ judge ~ permissionInfo:", permissionInfo)
    //   console.log("🚀 ~ Permission ~ judge ~ isPass:", isPass)
    // }
    
    if (needInfo && !isPass) {
      Vue.prototype.$toast.error(`无法${permissionInfo[index].name}，暂无相关权限`)
    }
    if (!this.permissionStateCache[room_id]) this.permissionStateCache[room_id] = {}
    !noCache && (this.permissionStateCache[room_id][cacheKey] = isPass)
    return isPass;
  }
  // 判断“我”对某个用户有没有某个权限
  //  roles: 要判断的用户的身份组
  //  user_id: 要判断的用户的id
  //  type: 要判断的权限的key
  //  channel_id: 要判断的频道的id，可选
  judgeUserPermission({roles, user_id, type, channel_id, room}) { 
    if (!user_id || !type) { 
      console.warn('judgeUserPermission 参数错误')
      return false
    }
    roles = roles || []
    room = room || this.cur_room_data || {}
    if (room.create_by == user_id) { // 如果判断的用户是房主，直接返回false
      return false
    }
    if (room.create_by == this.user_info.user_id) { // 如果我是房主，直接返回true
      return true
    }
    let user_position = this.calcUserPosition(roles, user_id) // 要判断的用户的权限等级
    let my_position = this.calcUserPosition(store.getters.cur_my_roles, this.user_info.user_id) // 我的权限等级
    // position越小权限越大
    if (user_position <= my_position) {
      return false
    }
    return this.judge(type, channel_id)
  }
  /**
   * 判断某个权限组在某个频道下是否有某个权限
   * @param {object} params - 参数对象
   * @param {string} params.role - 权限组对象
   * @param {string} params.type - 权限类型
   * @param {object | string} params.channel_data - 频道数据，可以是频道ID或包含room_id和channel_id的对象
   * @returns {boolean}
   */
  judgeRole({role, type, channel_data, channels}) {
    let permissions = role?.permissions;
    
    if(channel_data){
      if(channel_data.parent_id) {
        // 如果这个频道有parent_id，说明是分组中的频道，判断分组的权限
        channels = channels || store.getters.channels
        const parent_permission_overwrites = this.findChannelPermissionData(channel_data.parent_id, channels)
        if (parent_permission_overwrites) {
          let p_overwrite = parent_permission_overwrites?.find(o => o.role_id == role.id)
          let _group_permission = this.getSubPermissions(permissions, p_overwrite?.allow, p_overwrite?.deny);
          permissions = _group_permission || permissions // 分组权限计算后覆盖permissions字段，计算频道权限时基于分组的计算结果
        }
      }
      if(channel_data.permission_overwrites){
        const overwrite = channel_data.permission_overwrites.find(o => o.role_id == role?.id);
        if (overwrite) {
          const new_permissions = this.getSubPermissions(permissions, overwrite.allow, overwrite.deny);
          permissions = new_permissions || permissions;
        }
      }
    }
    // 检查角色是否具有指定的权限类型
    const permissionConfig = PERMISSION_CONFIGS.find(p => p.key === type);
    if (!permissionConfig) {
      Vue.prototype.$toast.error('未定义的权限类型');
      return false;
    }
  
    // 将权限转换为二进制列表并检查特定权限
    const permissionsList = transformToBinaryList(permissions);
    // 如果有管理员权限，则认为拥有所有权限
    if (permissionsList[0] === 1) {
      return true;
    }
    return !!permissionsList[permissionConfig.index];
  }

  // 根据是否有权限，判断是否要删除对应频道
  // 这里手动传roles和my_roles是由于在mutation中此时还没set room cache，所以无法从state里面拿到room.roles和room.my_roles
  judgeShowPrivateChannel ({channel, room_id, roles, my_roles, channels}) {
    if (!channel.is_private) return true
    // 如果有管理员权限，直接返回false
    channel.room_id = room_id
    const isManage = this.judge('ManageServer', channel, false, {roles, my_roles, channels})
    if (isManage) return true

    const user_perm = channel.user_perm || {}
    // 先判断用户是否有加入频道的权限
    const judgeAllow = (allow) => {
      if (allow == 0) return false
      let allow_list = transformToBinaryList(allow || 0, PERMISSION_CONFIGS.length)
      const viewingChannelIndex = PERMISSION_CONFIGS.findIndex(item => item.key === 'ViewingChannel')
      const canViewingChannel = !!allow_list[viewingChannelIndex]
      if (canViewingChannel) {
        return true
      }
      return false
    }
    if (judgeAllow(user_perm.allow || 0)) return true
    
    // 如果用户没有权限，判断用户在的频道组是否有权限
    // 先判断在不在频道组里，在的话在判断这个频道组有没有权限
    const permission_overwrites = channel.permission_overwrites || []
    for (let i = 0; i < permission_overwrites.length; i++) {
      const item = permission_overwrites[i]
      const role = roles.find(v => v.id == item.role_id)
      if (role) {
        if (my_roles.includes(role.id) && judgeAllow(item.allow || 0)) return true
      }
    }
    return false
  }

  clearPermissionCache(room_id, channel_id) {
    if (room_id && channel_id) {
      if (this.permissionStateCache[room_id]) {
        for (let k in this.permissionStateCache[room_id]) {
          if (k.includes(channel_id)) {
            delete this.permissionStateCache[room_id][k]
          }
        }
      }
    } else if (room_id) {
      delete this.permissionStateCache[room_id]
    } else {
      for (let k in this.permissionStateCache) {
        delete this.permissionStateCache[k]
      }
    }
  }
  /**
   * 获取当前判断权限的权限组
   * 
   * @description 1.29.0 优化逻辑，权限分成3个优先级，从高到低分别为当前用户的临时权限组、自定义权限组、原来的权限组
   * @param {*} room_id 当前房间ID， 用来获取自己原来的权限组
   * @param {*} my_roles_ids 当前传入的自定义权限组
   * @returns 
   */
  getJudgeRoles(room_id, my_roles_ids) {
    if (
      this.temp_role_data?.temp_role?.id && 
      this.temp_role_data?.room_id == this.cur_room_data.room_id
    ) {
      return [this.temp_role_data.temp_role.id]
    } else if (my_roles_ids){
      return my_roles_ids
    } else {
      return Cache.getRoomRoleCache(room_id).my_roles
    }
  }
  // 处理权限计算
  handlePermissionUpdate({channel_id, room_id, roles, my_roles_ids, channels, user_info}) {
    // 权限同级取或，非同级取与
    const room = (room_id === this.cur_channel_data.room_id) 
      ? this.cur_channel_data 
      : (room_id === this.cur_room_data.room_id)  
        ? this.cur_room_data 
        : {}; // 如果判断权限的频道是当前所在频道，直接使用频道中的频道所在房间数据
    const is_visitor = store.getters.cur_room_data_is_visitor
    my_roles_ids = this.getJudgeRoles(room_id, my_roles_ids);
    roles = roles || [...Cache.getRoomRoleCache(room_id).roles]
    const my_roles = JSON.parse(JSON.stringify(roles.filter(v => {
      return my_roles_ids.includes(v.id) 
        || (!is_visitor 
          ? v.type === ROLE_TYPES.everyone 
          : v.type === ROLE_TYPES.tourist)})))
    let whole_permission = BigInt(0);

    user_info = user_info || this.user_info
    if (room.create_by == user_info.user_id && !(this.temp_role_data?.temp_role?.id)) {
      // 创建者直接拥有所有权限(没有以某身份组查看时)
      return binaryListToBigIntNum(new Array(PERMISSION_CONFIGS.length).fill(1))
    }

    // 还没有 身份组 数据时 直接返回
    if (roles.length === 0) {
      return whole_permission
    }

    const punish_role = roles.find(v => v.type == ROLE_TYPES.punish)
    if (punish_role && my_roles_ids.includes(punish_role.id)) { 
      // 如果是惩罚身份组，只返回惩罚权限的结果
      whole_permission = BigInt(punish_role.permissions) || 0
    } else if (is_visitor) {
      // 游客仅走游客权限
      let visitorPermission = roles.find(v => v.type == ROLE_TYPES.tourist);
      visitorPermission = visitorPermission && visitorPermission.permissions || DEFAULT_TOURIST_PERMISSIONS;
      whole_permission = visitorPermission;
    } else {
      // 先处理全体成员默认权限
      let everyonePermission = roles.find(v => v.type == ROLE_TYPES.everyone)
      if (everyonePermission) {
        whole_permission = whole_permission | BigInt(everyonePermission.permissions)
      }
      // 处理房间身份组权限
      my_roles.forEach((v) => {
        // 先获取房间的全局权限
        whole_permission = whole_permission | BigInt(v.permissions);
      })
      // 如果有管理员权限，则认为拥有所有权限
      if (transformToBinaryList(whole_permission)[0] === 1) {
        whole_permission = binaryListToBigIntNum(new Array(PERMISSION_CONFIGS.length).fill(1))
      }

      // 果是某个分组的操作，需要判断频道/分组权限
      if (channel_id) {
        // 默认分组权限和房间权限一致，根据allow和deny进行权限增减
        let group_permission = null
        const channel = findChannelSync(channel_id, channels) || {};
        my_roles.forEach((v) => {
          if (channel && channel.parent_id) {
            // 如果这个频道有parent_id，说明是分组中的频道，判断分组的权限
            const parent_permission_overwrites = this.findChannelPermissionData(channel.parent_id, channels)
            if (parent_permission_overwrites) {
              let p_overwrite = parent_permission_overwrites?.find(o => o.role_id == v.id)
              let _group_permission = this.getSubPermissions(v.permissions, p_overwrite?.allow, p_overwrite?.deny);
              v.permissions = _group_permission // 分组权限计算后覆盖permissions字段，计算频道权限时基于分组的计算结果
              // 同级权限取或
              group_permission = group_permission ? group_permission | _group_permission : _group_permission
            }
          }
        })
        // 不同级权限覆盖
        if (group_permission) whole_permission = group_permission
        
        // 默认频道权限和房间权限一致，根据allow和deny进行权限增减
        let channel_permission = null
        my_roles.forEach((v) => {
          if (channel) {
            let overwrite = channel.permission_overwrites?.find(o => o.role_id == v.id)
            let _channel_permission = this.getSubPermissions(v.permissions, overwrite?.allow, overwrite?.deny);
              // 同级权限取或
            channel_permission = channel_permission ? channel_permission | _channel_permission : _channel_permission
          }
        })
        // 不同级权限覆盖
        if (channel_permission) whole_permission = channel_permission


        let user_permission = null
        let user_setted_permission = null
        let chan_perm = channel.user_perm
        if (chan_perm && user_info.user_id == this.user_info.user_id) {
          const parent_permission_obj = findChannelSync(channel.parent_id, channels)?.user_perm
          let parent_user_permissions
          if(parent_permission_obj) {
            parent_user_permissions = parent_permission_obj.allow
          } else {
            parent_user_permissions = '0'
          }
          user_permission = this.getSubPermissions(parent_user_permissions, chan_perm.allow, chan_perm.deny)
          user_setted_permission = this.getUserSettedPermission(chan_perm, parent_permission_obj)
        }
        if(user_setted_permission) {
          whole_permission = this.getUserPermission(user_permission, whole_permission, user_setted_permission)
        }
      }
    }
    return whole_permission
  }
  getPermissionInfo(permission) {
    let permission_config = JSON.parse(JSON.stringify(PERMISSION_CONFIGS))
    const userPermissions = transformToBinaryList(permission, permission_config.length);
    return permission_config.map((item, index) => {
      item.data = userPermissions[index];
      return item;
    });
  }
  getSubPermissions(parant_permission, allow = 0, deny = 0) {
    let origin = new Array(PERMISSION_CONFIGS.length).fill(null)
    let p_list = transformToBinaryList(parant_permission, PERMISSION_CONFIGS.length)
    let allow_list = transformToBinaryList(allow, PERMISSION_CONFIGS.length)
    let deny_list = transformToBinaryList(deny, PERMISSION_CONFIGS.length)
    return BigInt(binaryListToBigIntNum(origin.map((v, i) => {
      if (allow_list[i]) {
        return 1
      } else if (deny_list[i]) {
        return 0
      } else {
        return p_list[i]
      }
    })))
  }
  //从权限数组中取最高一位的权限作为此用户地位
  //  str[] role_ids =>  int position
  calcUserPosition(role_ids, user_id = '') {
    if(this.cur_room_data.create_by && this.cur_room_data.create_by == user_id) {
      // 房主 => 最高地位
      return Number.MIN_SAFE_INTEGER
    }
    if(!role_ids) {
      //兜底
      return Number.MAX_SAFE_INTEGER
    }
    let roles_map = new Map()
    let position = Number.MAX_SAFE_INTEGER
    store.getters.cur_roles_list.forEach(role => {
      roles_map.set(role.id, role)
    })
    role_ids.forEach(role_id => {
      let role = roles_map.get(role_id)
      if(role) position = Math.min(role.position, position)
    })
    return position
  }
  initProperty() {
    Object.defineProperty(this, 'cur_room_data', {
      get: function() {
        return store.getters.cur_room_data
      },
    })
    Object.defineProperty(this, 'cur_room_whole_data', {
      get: function() {
        return store.getters.cur_room_whole_data
      },
    })
    Object.defineProperty(this, 'cur_channel_data', {
      get: function() {
        return store.getters.cur_channel_data
      },
    })
    Object.defineProperty(this, 'user_info', {
      get: function() {
        return store.getters.user_info
      },
    })
    Object.defineProperty(this, 'temp_role_data', {
      get: function() {
        return store.getters.temp_role_data
      },
    })
  }
  // 获取用户单独设置的权限
  getUserSettedPermission(chan_perm = {}, parent_perm = {}) {
    const {
      allow: chanAllow = '0',
      deny: chanDeny = '0'
    } = chan_perm;
    const {
      allow: parentAllow = '0',
      deny: parentDeny = '0'
    } = parent_perm;

    // 快速检查是否所有值都为0
    if (chanAllow === '0' && chanDeny === '0' && parentAllow === '0' && parentDeny === '0') {
      return BigInt(0);
    }

    const chanAllowNum = BigInt(chanAllow);
    const chanDenyNum = BigInt(chanDeny);
    const parentAllowNum = BigInt(parentAllow);
    const parentDenyNum = BigInt(parentDeny);

    const combined = chanAllowNum | chanDenyNum | parentAllowNum | parentDenyNum;
    
    if (combined !== BigInt(0)) {
      const mask = (BigInt(1) << BigInt(PERMISSION_CONFIGS.length)) - BigInt(1);
      return combined & mask;
    }
    
    return BigInt(0);
  }

  // 根据频道的单个用户设置数据和权限组权限数据计算出真正的权限值
  getUserPermission(user_permission, role_permission, user_setted_permission) {
    const userPerm = user_permission;
    const rolePerm = role_permission;
    const userSettedPerm = user_setted_permission;
    
    const result = (userPerm & userSettedPerm) | (rolePerm & ~userSettedPerm);
    return result;
  }
}

const permission = new Permission()
// 用户debug时使用
window._Room_Permission = permission
export default permission;